export const REMOVE_TABLE_ROW_DIALOG_OPENED = "REMOVE_TABLE_ROW_DIALOG_OPENED";
export const REMOVE_TABLE_ROW_DIALOG_CLOSED = "REMOVE_TABLE_ROW_DIALOG_CLOSED";
